import React from 'react';
import { Translation } from 'react-i18next';
import Button from '@websky/core/src/Button/Button';
import theme from './FullScreenDialogCloseButton.css';
const CloseButton = ({ onClose }) => {
    return (React.createElement(Translation, { ns: 'FullscreenDialog' }, t => (React.createElement(Button, { className: theme.closeButton, onClick: onClose }, t('Close')))));
};
export default CloseButton;
